import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";

const FAQS = [
  {
    id: "q1",
    question: "What is Fanible?",
    answer: "Fanible is a mobile app designed for sports fans to connect, share, and engage with each other. It's a platform where fans of all sports can come together, post updates, share opinions, and discuss the latest games and news. Whether you're passionate about cricket, football, basketball, or any other sport, Fanible provides a space for fans to create and engage in community posts, build connections, and celebrate their love for sports with like-minded individuals.",
  },
  {
    id: "q2",
    question: "What are the features of the Fanible app?",
    answer: "Fanible offers real-time sports updates, personalised content, and a platform for fans to share posts and engage in discussions. It allows you to connect with like-minded sports enthusiasts, stay updated with live scores and news, and participate in fan challenges. With a sleek interface, you can easily follow your favourite sports and teams, and never miss out on any game or event.",
  },
  {
    id: "q3",
    question: "Is the Fanible app safe and secure?",
    answer: "Yes, Fanible is committed to keeping your data safe and secure. We use industry-standard encryption and security protocols to protect your personal information. Your privacy is our priority, and we ensure that all data shared within the app is stored and handled securely.",
  },
  {
    id: "q4",
    question: "How can I create an account on Fanible?",
    answer: "Creating an account on Fanible is simple! Just download the app from the Google Play Store or Apple App Store, sign up using your email or social media account, and you're all set to start connecting with fellow sports fans and enjoying all the features.",
  },
  {
    id: "q5",
    question: "Is the Fanible app available for both Android and iOS?",
    answer: "Yes, Fanible is available for download on both the Google Play Store for Android users and the Apple App Store for iOS users.",
  },
  {
    id: "q6",
    question: "Which sports does Fanible have a community for?",
    answer: "Fanible has communities for a wide range of sports, including cricket, football, basketball, tennis, kabaddi, hockey, badminton, esports, and more. Whether you're passionate about national or international sports, you'll find a place to connect with like-minded fans.",
  },
  {
    id: "q7",
    question: "Who is the CEO of Fanible?",
    answer: "Dinkar, currently designated as the CEO of Fanible, is also the owner of the company. He founded Fanible with the vision to create a dynamic platform that unites sports fans from all walks of life, allowing them to connect, share, and celebrate their love for sports.",
  },
  {
    id: "q8",
    question: "When was Fanible founded?",
    answer: "Fanible was founded on 7th July, 2025, with the goal of creating a space where sports fans can connect, engage, and celebrate their love for sports.",
  },
];

export default function FAQModal({ open, onClose }) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="bg-[#0E1117] border border-white/10 text-white max-w-2xl rounded-2xl max-h-[85vh] overflow-y-auto p-0">
        <DialogDescription className="sr-only">Frequently Asked Questions about Fanible</DialogDescription>

        {/* Header */}
        <div className="relative px-8 pt-10 pb-8 border-b border-white/8"
          style={{ background: "linear-gradient(135deg, #0A0D1F 0%, #0E1117 60%)" }}>
          <div className="absolute inset-0 opacity-[0.03]"
            style={{ backgroundImage: "linear-gradient(#3B9EFF 1px, transparent 1px), linear-gradient(90deg, #3B9EFF 1px, transparent 1px)", backgroundSize: "40px 40px" }} />
          <DialogHeader className="relative">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-6 h-px bg-[#3B9EFF]" />
              <span className="text-[10px] uppercase tracking-[0.25em] font-bold text-[#3B9EFF] font-outfit">Support</span>
            </div>
            <DialogTitle className="font-outfit font-black text-3xl sm:text-4xl tracking-tight text-white text-left">
              Frequently Asked <span className="text-[#3B9EFF]">Questions</span>
            </DialogTitle>
            <p className="text-[#A1A1AA] text-sm mt-2 font-inter">Everything you need to know about Fanible.</p>
          </DialogHeader>
        </div>

        <div className="px-8 py-8">
          <Accordion type="single" collapsible className="space-y-2">
            {FAQS.map((faq, i) => (
              <AccordionItem
                key={faq.id}
                value={faq.id}
                className="bg-[#191D27] border border-white/6 rounded-xl px-5 data-[state=open]:border-[#3B9EFF]/30 transition-colors duration-200"
                style={{ borderBottom: "none" }}
              >
                <AccordionTrigger className="text-white text-sm font-semibold font-outfit hover:no-underline hover:text-[#3B9EFF] transition-colors duration-200 py-4 text-left">
                  <span className="flex items-center gap-3">
                    <span className="text-[#3B9EFF] font-outfit font-black text-xs w-5 flex-shrink-0">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    {faq.question}
                  </span>
                </AccordionTrigger>
                <AccordionContent className="text-[#A1A1AA] text-sm leading-relaxed font-inter pb-5 pl-8">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

      </DialogContent>
    </Dialog>
  );
}
